module.exports = __webpack_public_path__ + "static/media/totalAmount.d69a75d2.svg";